// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"40":"080496ba","195":"9569f9ef","313":"2287e50b","378":"8c9ecd81","671":"2679b518"}[chunkId] + ".js";
};